import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import {
  category_badge,
  cardText,
  lightCard
} from './cardStyles.module.css'
const removeMd = require('remove-markdown');
const _ = require('lodash')


const ModuleLightCard = props => {
  function categoryLink(props){
    if (props.postType === 'Real Estate'){
      return  <div style={{margin:'10px 0px 0px 10px'}}><div style={{marginBottom:'0px'}} className={category_badge}><Link to={`/realestate/${_.kebabCase(props.slug)}/`}>Real Estate</Link></div></div>

    }else if (props.postType === 'Author'){
      return  <div  style={{marginBottom:'0px', marginLeft:'10px'}} className={category_badge}><Link to={`/authors/${_.kebabCase(props.slug)}/`}>Author</Link></div>

    }else if (props.postType === 'Post'){
      return(
        <div style={{margin:'10px 0px 0px 10px'}}>
        {props.categories.map((category, index) => {
        return(
          <div style={{marginBottom:'0px'}} key={index} className={category_badge}><Link to={`/category/${_.kebabCase(category.slug)}/`}>{category.title}</Link></div>
          )
        })}
        </div>
      )

    }
  }

  function excerpt(props){
    if (props.postType === 'Real Estate'){
      return  (
        <div style={{padding:'0em .5em 1em .5em'}}>
        <Link to={`/realestate/${_.kebabCase(props.slug)}/`}>
        <h4 style={{wordBreak:'break-word'}}>{props.title}</h4>
        <div className ={cardText}>
        <p style={{fontSize:'.9rem'}}>{props.address}</p>
        <h5 style={{color:'#8fc744'}}>{props.price}</h5>
        </div>
        </Link>
        </div>
      )
    }else if (props.postType === 'Author'){
      var authorString = removeMd(props.excerpt);
      return  (
        <div style={{padding:'0em .5em 1em .5em'}}>
        <Link to={`/authors/${_.kebabCase(props.slug)}/`}>
        <h4 style={{wordBreak:'break-word'}}>{props.title}</h4>
        <div className ={cardText}>
        <p
          dangerouslySetInnerHTML={{
            __html:authorString.split(" ").splice(0,20).join(" ") + '...',
          }}
        />
        </div>
        </Link>
        </div>
      )
    }else if (props.postType === 'Post'){
      var postString = removeMd(props.excerpt);
      return(
        <div style={{padding:'0em .5em 1em .5em'}}>
        <span className={'lightCardDate'} style={{fontSize:'.7em', color:'#666', display:'inline-block'}}>{props.date}</span>
        <Link to={`/${props.slug}/`}>
        <h4 style={{wordBreak:'break-word'}}>{props.title}</h4>
        <div className ={cardText}>
        <p
          dangerouslySetInnerHTML={{
            __html:postString.split(" ").splice(0,20).join(" ") + '...',
          }}
        />
        </div>
        </Link>
        </div>
      )
    }
  }
  function image(props){
    if (props.postType === 'Real Estate'){
      return(
        <Link to={`/realestate/${_.kebabCase(props.slug)}/`}>
          <GatsbyImage
            image={props.image.gatsbyImageData}
            alt={props.image.title}
          />
        </Link>
      )

    }else if (props.postType === 'Author'){
      return(
        <Link to={`/authors/${_.kebabCase(props.slug)}/`}>
          <GatsbyImage
            image={props.image.gatsbyImageData}
            alt={props.image.title}
          />
        </Link>
      )
    }else if (props.postType === 'Post'){
      return(
        <Link to={`/${props.slug}/`}>
          <GatsbyImage
            image={props.image.gatsbyImageData}
            alt={props.image.title}
          />
        </Link>
      )
    }
  }


return (
  <div className={`${lightCard} ${props.columns}  ${'darkModeMidBackground'}`}>

      {props.image &&
        image(props)
      }
        {categoryLink(props)}
        {excerpt(props)}



  </div>
  )
}

export default ModuleLightCard
